import React, { useCallback, useEffect, useReducer, useState } from "react"
import { obterAvaliacoesDelivery } from "../../../services/avaliacaoDelivery"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { AvaliacaoDeliveryActionsTypes } from "./avaliacaoDeliveryActions"
import { AvaliacaoDeliveryContext } from "./AvaliacaoDeliveryContext"
import { AvaliacaoDeliveryInicial, avaliacaoDeliveryReducer } from "./avaliacaoDeliveryReducer"

export function AvaliacaoDeliveryContextProvider({ children }: { children: React.ReactNode }) {
    const [dados, dispatch] = useReducer(avaliacaoDeliveryReducer, AvaliacaoDeliveryInicial)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const pesquisar = useCallback(
        async (inicio?: number, fim?: number) => {
            const autorizacao = localStorage.getItem("chaveSistema")
            if (!autorizacao) return
            const inicioParaUsar = inicio ?? dados.inicioMs
            const fimParaUsar = fim ?? dados.fimMs
            try {
                setLoading(true)
                const response = await obterAvaliacoesDelivery(
                    autorizacao,
                    inicioParaUsar,
                    fimParaUsar
                )
                if ("retornoErro" in response) {
                    setErroCarregamento(response.mensagem || "Erro ao carregar avaliações")
                } else {
                    setErroCarregamento(null)
                    dispatch({ type: AvaliacaoDeliveryActionsTypes.CARREGAR, payload: response })
                }
            } catch {
                setErroCarregamento("Erro ao carregar avaliações")
            } finally {
                setLoading(false)
            }
        },
        [dados.inicioMs, dados.fimMs]
    )

    useEffect(() => {
        pesquisar()
    }, [])

    return (
        <AvaliacaoDeliveryContext.Provider value={{ dados, dispatch, pesquisar, erroCarregamento }}>
            <Loading />
            {children}
        </AvaliacaoDeliveryContext.Provider>
    )
}
